import { render, staticRenderFns } from "./StuffPrice.vue?vue&type=template&id=bf1f80a0&"
import script from "./StuffPrice.vue?vue&type=script&lang=js&"
export * from "./StuffPrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports